// extracted by mini-css-extract-plugin
export var error = "Error-module--error--3RyTZ";
export var animateIn = "Error-module--animateIn--1XrDk";
export var image = "Error-module--image--2o2hC";